import React from 'react';
export function SkeletonYearLineChart() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-6 flex w-full items-center justify-between h-[32px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-8 w-10 rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-8 w-10 rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-8 w-24 rounded bg-slate-200 animate-pulse"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-8 w-16 rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-8 w-16 rounded-full bg-slate-200 animate-pulse"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "relative flex-1 w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute inset-0 grid grid-cols-12 grid-rows-5"
    }, Array.from({
        length: 60
    }).map((_, i) => /*#__PURE__*/ React.createElement("div", {
        key: i,
        className: "border-b border-r border-slate-100"
    }))), /*#__PURE__*/ React.createElement("svg", {
        className: "absolute inset-0 h-full w-full",
        viewBox: "0 0 1000 300",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: " M 0 120 L 90 150 L 180 140 L 270 180 L 360 145 L 450 110 L 540 80 L 630 160 L 720 260 L 810 260 L 900 255 L 1000 260 ",
        fill: "none",
        stroke: "#3b82f6",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "skeleton-line"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "absolute bottom-0 left-0 right-0 flex justify-between text-xs text-slate-300"
    }, ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"].map(m => /*#__PURE__*/ React.createElement("span", {
        key: m
    }, m)))));
}
